<div class="CreateGroup" [formGroup]="inputForm">
  <p>Enter Group Name</p>
  <app-text-field
    placeholder="Group name"
    formControlName="group_name"></app-text-field>
  <mat-error
    *ngIf="
      (groupName.touched || groupName.dirty) &&
      !groupName.valid &&
      groupName.errors?.required
    "
    >Please, enter a group name</mat-error
  >
</div>
